module.exports = __webpack_public_path__ + "static/img/course-3.046e667c.jpg";